/* 🤖 this file was generated by svg-to-ts */
export const IconBigBoldOk: {
    name: 'big-bold-ok';
    data: string;
} = {
    name: 'big-bold-ok',
    data: `<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 128 128"><path d="M38.55 110.82a11.4 11.4 0 0 1-8.16-3.39L2.68 79.54A7.5 7.5 0 0 1 13.32 69l25.23 25.4 76.13-76.65a7.5 7.5 0 1 1 10.64 10.58l-78.62 79.1a11.4 11.4 0 0 1-8.15 3.39"/></svg>`,
};
